export default __webpack_public_path__ + "static/media/logo-white.9d66e896.svg";